import React from 'react';
import { Radio, Space } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ACTIONS } from './constants';
import { FormItem } from './styles';

interface ActionsProps {
	fieldName: string[];
}

export function Actions({ fieldName }: Readonly<ActionsProps>) {
	return (
		<FormItem name={[...fieldName, 'action']}>
			<Radio.Group>
				<Space direction="vertical">
					<Radio value={ACTIONS.MAINTENANCE.value}>{I18n.get(ACTIONS.MAINTENANCE.label)}</Radio>
					<Radio value={ACTIONS.CHANGE.value}>{I18n.get(ACTIONS.CHANGE.label)}</Radio>
					<Radio value={ACTIONS.PROVIDE.value}>{I18n.get(ACTIONS.PROVIDE.label)}</Radio>
				</Space>
			</Radio.Group>
		</FormItem>
	);
}
